/* eslint-disable max-len */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-multi-comp */
/* eslint-disable import/extensions */
import React, { Fragment } from 'react';
import { withRouter } from 'react-router';
import cn from 'classnames';
import { connect } from 'redux-zero/react';
import { injectIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import Media from 'react-media';

import { actions } from '../../shared/store.js';
import StoriesService from './stories.service.js';

import { Title } from '../../components/title/title.component.js';
import StoriesCard from '../../components/stories/stories-card.page.js';
import SearchableDropdown from '../../components/searchable-dropdown/searchable-dropdown.js';

import noDataCompanies from '../../assets/images/portfolio/company.svg';

import './stories.page.scss';

const LIMIT = 6;

const Category = ({
	category, handleCategory, index, chosenCategory,
}) => (
	<Fragment>
		<div
			className={`category-box ${cn({ active: index === chosenCategory })}`}
			onClick={handleCategory}
		>
			<div className="icon">
				{category.icon_white && index === chosenCategory ? (
					<img
						src={`${process.env.REACT_APP_API_ENDPOINT
							+ category.icon_white.path}`}
						alt={category.label}
					/>
				) : (
					category.icon && (
						<img
							src={`${process.env.REACT_APP_API_ENDPOINT + category.icon.path}`}
							alt={category.label}
						/>
					)
				)}
			</div>
			<div className="category">{category.label}</div>
		</div>
	</Fragment>
);


class HeaderSection extends React.Component {
	render() {
		const { title } = this.props;
		return (
			<section className="header">
				<div className="container container-fluid">
					<div className="row">
						<div className="col-xs-12 col-md-12 ">
							<Title label={title} theme="dark" />
						</div>
					</div>
				</div>
			</section>
		);
	}
}

class StoriesPage extends React.Component {
	static prefetchData = async (language, skip = 0) => Promise.all([
		StoriesService.getCategories(language),
		StoriesService.getData(language),
		StoriesService.getStoriesList({
			language, limit: LIMIT, skip, value: '',
		}),
		StoriesService.getPartnersName(language),
	]);

	constructor(props) {
		super(props);

		this.state = {
			chosenCategory: -1,
			stories: props.storiesList ? props.storiesList.data.entries : [],
			hideOverlayButtonTop: false,
			isSubmiting: false,
			hasFormError: false,
			dropOpen: true,
			isOpen: false,
			selectedCompany: null,
		};

		this.overlayButtonTopRef = React.createRef();

	}

	componentDidMount() {
		const {
			storiesData,
			storiesCategories,
			storiesList,
			setLoading,
			showButton,
			hidebutton,
			partnerData,
		} = this.props;

		this.overlayButtonTopRef = new IntersectionObserver((entries) => {
			const topButton = entries[0];

			if (!topButton.isIntersecting) {
				showButton();
			} else {
				hidebutton();
			}
		});

		if (!storiesData || !storiesCategories || !storiesList || !partnerData) {
			this.fetchData();
		} else {
			setLoading(false);
		}
	}

	changeCategory = ({ index, category }) => {
		const { language, setStoriesList } = this.props;
		const { selectedCompany } = this.state;
		this.goTop();
		this.closeDrop();

		StoriesService.getStoriesList({
			limit: LIMIT,
			language,
			category: category.id === 'all' ? null : category._id,
			partner: !selectedCompany ? null : selectedCompany.id,
		}).then((results) => {
			this.setState({
				chosenCategory: category === 'all' ? -1 : index,
				stories: results.data.entries.map(story => ({ ...story })),
			});
			setStoriesList({
				data: results.data.entries.map(story => ({ ...story })),
				total: results.data.total,
			});
		});
	};

	filterByCompany = (company) => {
		const { setStoriesList, language, storiesCategories } = this.props;
		const { chosenCategory } = this.state;

		StoriesService.getStoriesList({
			limit: LIMIT,
			language,
			category: chosenCategory === -1 ? null : storiesCategories.data.entries[chosenCategory]._id,
			partner: company.id,
		}).then((results) => {
			this.setState({
				stories: results.data.entries.map(story => ({ ...story })),
			});
			setStoriesList({
				data: results.data.entries.map(story => ({ ...story })),
				total: results.data.total,
			});
		});
	}

	closeDrop = () => {
		this.setState(prevState => ({
			dropOpen: !prevState.dropOpen,
		}));
	};

	goTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

	loadMoreNews = () => {
		this.fetchStories();
	};

	fetchStories = () => {
		const {
			setStoriesList,
			storiesList,
			storiesCategories,
			language,
		} = this.props;

		const { chosenCategory } = this.state;

		StoriesService.getStoriesList({
			language,
			limit: LIMIT,
			skip: storiesList.data.length,
			category:
				chosenCategory === -1
					? undefined
					: storiesCategories.data.entries[chosenCategory]._id,
		}).then((response) => {
			const oldList = Array.from(storiesList.data);
			setStoriesList({
				data: oldList.concat(response.data.entries),
				total: storiesList.total,
			});
		});
	};

	selectCompany = (company) => {
		this.setState({ selectedCompany: company });
		this.filterByCompany(company);
	};


	fetchData(skip = 0, showLoader = true) {
		const {
			setLoading,
			setStoriesCategories,
			setStoriesList,
			storiesList,
			setStoriesData,
			setPartnerData,
			language,
		} = this.props;

		if (showLoader) setLoading(true);

		StoriesPage.prefetchData(language.value, skip)
			.then(([storiesCategories, storiesPageData, newStoriesList, partnerData]) => {
				setStoriesCategories(storiesCategories);
				setStoriesData(storiesPageData);
				setPartnerData(partnerData);
				if (storiesList !== null && skip !== 0) {
					const oldList = Array.from(storiesList.data);
					setStoriesList({
						data: oldList.concat(newStoriesList.data.entries),
						total: storiesList.total,
					});
				} else {
					setStoriesList({
						data: newStoriesList.data.entries,
						total: newStoriesList.data.total,
					});
					this.setState({ stories: newStoriesList.data.entries });
				}
				if (showLoader) setLoading(false);
			})
			.catch(() => {
				if (showLoader) setLoading(false);
				const { history } = this.props;
				history.push('/404');
			});
	}


	render() {
		const {
			chosenCategory,
			dropOpen,
			hideOverlayButtonTop,
		} = this.state;
		const {
			intl,
			storiesData,
			storiesCategories,
			storiesList,
			partnerData,
			hasError,
		} = this.props;

		if (hasError || !storiesData || !storiesCategories || !storiesList) {
			return null;
		}
		const { title } = storiesData;

		return (
			<div id="stories-page">
				<Helmet>
					<title>{storiesData.title}</title>

					<title>
						{intl.formatMessage({
							id: 'navigation.portfolio',
						})}
					</title>

					{/* TODO */}
					<meta
						name="description"
						content=""
					/>
					<link
						rel="canonical"
						href={`${
							process.env.REACT_APP_URL
						}/stories`}
					/>

					<meta
						property="og:url"
						content={`${
							process.env.REACT_APP_URL
						}/stories`}
					/>

				</Helmet>
				<HeaderSection title={title} />

				<section className="categories-section">
					<div className="container container-fluid">
						<div className="row">
							<div className="col-xs-12 col-sm-4 col-md-7 left-categories">
								<div className="category-wrapper">
									<Media query="(min-width: 62em)">
										{matches => (matches ? (
											<Fragment>
												<Category
													category={{ label: 'All' }}
													chosenCategory={chosenCategory}
													index={-1}
													handleCategory={() => this.changeCategory({
														index: -1,
														category: 'all',
													})
													}
												/>
												{storiesCategories.data.entries.map(
													(category, index) => (
														<Category
															category={category}
															chosenCategory={chosenCategory}
															index={index}
															handleCategory={() => this.changeCategory({ index, category })
															}
															key={category._id}
														/>
													),
												)}
											</Fragment>
										) : (
											<div className="dropdown">
												<button
													type="button"
													className="dropbtn"
													onClick={() => this.changeCategory({
														index: chosenCategory,
														category:
																	chosenCategory === -1
																		? 'all'
																		: storiesCategories.data.entries[
																			chosenCategory
																		],
													})
													}
												>
													{chosenCategory === -1 && <Fragment>All</Fragment>}
													{chosenCategory !== -1
															&& storiesCategories.data.entries[chosenCategory]
																.label}
												</button>
												<div
													className={cn(
														{ close: dropOpen },
														'dropdown-content',
													)}
												>
													<span
														onClick={() => this.changeCategory({
															index: -1,
															category: 'all',
														})
														}
													>
														{intl.formatMessage({
															id: 'stories.all',
														})}
													</span>
													{storiesCategories
															&& storiesCategories.data.entries.map(
																(category, index) => (
																	<span
																		onClick={() => this.changeCategory({ index, category })
																		}
																	>
																		{category.id}
																	</span>
																),
															)}
												</div>
											</div>
										))
										}
									</Media>
								</div>
							</div>
							<div className="col-xs-12 col-sm-8 col-md-5 by-company-wrapper">
								<h6>{intl.formatMessage({ id: 'stories.companyDrop' })}</h6>

								<SearchableDropdown
									companies={partnerData.data.entries}
									handleSelect={this.selectCompany}
								/>

							</div>
						</div>
					</div>
				</section>

				<section className="stories-section">
					<div className={cn('button-wrapper', { hide: hideOverlayButtonTop })}>
						<button type="button" className="oval-button" onClick={this.goTop}>
							<span className="arrow" />
						</button>
					</div>
					<div className="container container-fluid">
						<div className="row center-xs start-lg stories-wrapper">
							{storiesList.data.length > 0
								&& storiesList.data.map(stories => (
									<StoriesCard storiesList={stories} />
								))}
							{storiesList.data.length === 0 && (
								<div className="col-xs-12 center-xs">
									<div className="no-data">
										<img src={noDataCompanies} alt="No companies" />
										<h6>
											{intl.formatMessage({
												id: 'stories.no_data.no_companies',
											})}
										</h6>
										<span>
											{intl.formatMessage({
												id: 'stories.no_data.no_companies.select_other',
											})}
										</span>
									</div>
								</div>
							)}
						</div>
						{storiesList.total > storiesList.data.length
							&& storiesList.data.length > 0 && (
							<div className="load-more">
								<div className="load-more-button" onClick={this.loadMoreNews}>
									{intl.formatMessage({ id: 'stories.loadMore' })}
								</div>
							</div>
						)}
					</div>
				</section>
			</div>
		);
	}
}

const mapToProps = ({
	language,
	storiesData,
	storiesCategories,
	storiesList,
	partnerData,
	isLoading,
}) => ({
	language,
	storiesData,
	storiesCategories,
	storiesList,
	partnerData,
	isLoading,
});

export default withRouter(
	injectIntl(
		connect(
			mapToProps,
			actions,
		)(StoriesPage),
	),
);

export { StoriesPage };
